export default function validation(response, messages) {
  if (!response?.data?.error?.validationErrors) {
    if (response?.data?.error?.message === 'Exception of type \'Abp.Domain.Entities.EntityNotFoundException\' was thrown.') {
      messages.push({ message: 'validation.notAccess' });
    }
    return;
  }
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('BESOIN_CANNOT_BE_REMOVED') === 0) {
      const splitMessage = message.split('|')[0].split('@');
      messages.push({
        message: 'editionCommande.logistiqueImpression.affiches.besionCannotBeRemoved',
        parametres: {
          libelle: splitMessage[1],
        },
      });
    }
    if (message.indexOf('BESOIN_CANNOT_BE_GENERATED') === 0) {
      messages.push({
        message: 'editionCommande.logistiqueImpression.affiches.besionCannotBeGenerated',
      });
    }
    if (message.indexOf('BESOIN_CANNOT_BE_MODIFIED') === 0) {
      messages.push({
        message: 'editionCommande.logistiqueImpression.affiches.besionCannotBeModified',
      });
    }
    if (message.indexOf('BESOIN_CANNOT_BE_ORDERED_WITHOUT_DELIVERY_DATE') === 0) {
      messages.push({
        message: 'editionCommande.logistiqueImpression.affiches.besionCannotBeOrderedWithoutDeliveryDate',
      });
    }
    if (message.indexOf('BESOIN_CANNOT_BE_ORDERED_WITHOUT_DELIVERY_PLACE') === 0) {
      messages.push({
        message: 'editionCommande.logistiqueImpression.affiches.besionCannotBeOrderedWithoutDeliveryPlace',
      });
    }
    if (message.indexOf('BESOIN_CANNOT_BE_ORDERED_WITHOUT_PRODUCT') === 0) {
      messages.push({
        message: 'editionCommande.logistiqueImpression.affiches.besionCannotBeOrderedWithoutProduct',
      });
    }
    if (message.indexOf('BESOIN_CANNOT_BE_ORDERED_WITHOUT_QUANTITY') === 0) {
      messages.push({
        message: 'editionCommande.logistiqueImpression.affiches.besionCannotBeOrderedWithoutQuantity',
      });
    }
    if (message.indexOf('BESOIN_CANNOT_BE_ORDERED_WITHOUT_SUPPLIER') === 0) {
      messages.push({
        message: 'editionCommande.logistiqueImpression.affiches.besionCannotBeOrderedWithoutSupplier',
      });
    }
    if (message.indexOf('BESOIN_CANNOT_BE_ORDERED_AGAIN') === 0) {
      messages.push({
        message: 'editionCommande.logistiqueImpression.affiches.besionCannotBeOrderedAgain',
      });
    }
  });
}
